export const TOUR_ANCHORS = {
  tabBar: 'tab-bar',
  tab: (tabId: string) => `tab-${tabId}`,
  tabContent: (tabId: string) => `tab-content-${tabId}`,
  feedFilter: 'feed-filter',
  feedMessage: 'feed-message',
  feedRow: 'feed-row',
  careTeamChat: 'care-team-chat',
  careTeamChatButton: 'care-team-chat-button',
  panel: (panelId: string) => `panel-${panelId}`,
  caseload: 'caseload',
  caseloadView: 'caseload-view',
  infoArea: 'info-area',
  symptomSurveys: 'symptom-surveys',
  careTeam: 'care-team',
} as const

const attribute = (anchor: string) => `[data-tour="${anchor}"]`

export const tourSelector = (...anchors: string[]): string => anchors.map(attribute).join(' ')
